import formatText from "./formatText"
import coordinates from "./coordinates"
export default {
  formatText,
  coordinates,
}
